module.exports = __webpack_public_path__ + "img/icon3.a75947d8.png";